import { render } from "./ManagerUser.vue?vue&type=template&id=e9d8dc60"
import script from "./ManagerUser.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ManagerUser.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script